import { CircularProgress } from "@mui/material";
import { useFormik } from "formik";
import { useState, useEffect, Fragment } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import * as Yup from 'yup';
import TextInput from "../common/textfield/TextInput";
import SelectField from "../common/textfield/SelectField";
import TextArea from "../common/textfield/TextArea";
import Radio from "../common/textfield/Radio";
import { Button } from "../common/Button";
import Fields from "./Fields";

const QuestionnaireGetCare = ({ questionnaireModalShow, handleQuestionnaireModalClose, questions, openProviderModal }) => {
    const [isLoading, setIsLoading] = useState(false);
    const qKey = (q) => q?.id || `link-${q?.linkId}`;


    const formik = useFormik({
        initialValues: {
                questionResponse: [],
        },


        validationSchema: Yup.object({}),
        onSubmit: (values, {setFieldError}) => {
            console.log("Form values on submit: ", values);
            const result = validateQuestionnaire(values, setFieldError);
            if (!result.isValid) {
                console.log("Validation failed: ", result.reason);
                return;
            }
            let concatenatedAnswerExt;
            let telephoneAnswer;
            const telephoneQuestion = values.questionResponse.find(
              (question) => question.tag === "TELEPHONE"
            );
            const getLocationQuestion = values.questionResponse.find(
              (question) => question.tag === "LOCATION"
            );
            let selectedLocation = getLocationQuestion?.answer?.[0]?.answer;
            console.log("Selected Location: ", selectedLocation);
            if (telephoneQuestion) {
              telephoneAnswer = telephoneQuestion?.answer;
              concatenatedAnswerExt =
                telephoneQuestion?.answer?.[1] !== undefined
                  ? telephoneAnswer[0]?.answer +
                    " ext " +
                    telephoneAnswer[1]?.answer
                  : telephoneAnswer[0]?.answer;
              telephoneAnswer.splice(1, 1);
              telephoneAnswer[0].answer = concatenatedAnswerExt;
              telephoneAnswer[0].required = true;
              telephoneAnswer[0].option = null;
              telephoneAnswer[0].value = null;
              telephoneAnswer[0].name = null;
            }
            const questionResponse = values.questionResponse?.map((item) => ({
              id: item?.linkId,
              questionId: item?.id  || null,
              question: item?.text,
              answer: item?.answer,
              questionType: item?.answerType,
              required: item?.required,
              tag: item?.tag || null,
            }));
            console.log("Final questionResponse to submit: ", questionResponse);

            
            handleQuestionnaireModalClose();
            openProviderModal(questionResponse, selectedLocation);
        }
    });

    const handleRadioChange = (question, value) => {
        formik.setFieldValue(question, value);
    };

    const validateQuestionnaire = (values, setFieldError) => {
        const responses = values?.questionResponse ?? [];

        if (!Array.isArray(responses) || responses.length === 0) {
            return { isValid: false, reason: "No answers submitted" };
        }

        let hasError = false;

        responses.forEach((question, index) => {
            if (!question?.required) return

            if (question.answerType === "radio") {
            if (!question.answer?.some((a) => !!a?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                hasError = true;
            }
            return;
            }

            if (question.answerType === "checkbox") {
            if (!question.answer?.some((a) => !!a?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                hasError = true;
            }
            return;
            }

            if (question.answerType === "dropDown" || question.answerType === "freeText") {
            const value = question.answer?.[0]?.answer?.trim();
            if (!value) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                hasError = true;
            }
            }
        });

        if (hasError) {
            return { isValid: false, reason: "One or more fields are invalid" };
        }

        const telePhoneField = responses.find((r) => r.tag === "TELEPHONE")?.answer?.[0]?.answer;
        const phonePattern = /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/;

        if (telePhoneField && !phonePattern.test(telePhoneField)) {
            return { isValid: false, reason: "Invalid phone format" };
        }

        return { isValid: true };
    };


    useEffect(() => {
        formik.setFieldValue(
        "questionResponse",
        questions?.map((item) => {
            const isTrue =
            item?.answerType === "freeText" || item?.answerType === "dropDown";
            const isDropDown = item?.answerType === "dropDown";
            return {
            ...item,
            answer: item?.answerOption?.map((option) => {
                return {
                id: option?.id,
                required: item?.required,
                answer: isTrue ? "" : false,
                option: isTrue ? isDropDown ? option.text : null : option?.text,
                value: isDropDown ? option.text : null,
                name: isDropDown ? option.text : null,
                };
            }),
            };
        })
        );
    }, [questions]);
    return (
        <section>
            {isLoading ? (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh"
                }}>
                    <CircularProgress size={50} />
                </div>
            ) : (
                <Modal
                    backdropClassName
                    backdrop={'static'}
                    size='lg'
                    show={questionnaireModalShow} onHide={handleQuestionnaireModalClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered className="custom-dialog">

                    <Modal.Header closeButton className="border-0">
                        <Modal.Title id="contained-modal-title-vcenter">Questions</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <form className="common-form border-fields" onSubmit={formik.handleSubmit}>

                            {questions?.map((question, index) => (
                                <Fragment key={index}>
                                    <Fields
                                        question={question}
                                        Questions={questions}
                                        formik={formik}
                                        propIndex={index}
                                    />
                                </Fragment>
                            ))}

                            <div className="action-wrap">
                                <Button type="submit" disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} /> : 'Next'}
                                </Button>
                            </div>
                        </form>

                    </Modal.Body>
                </Modal>
            )}
        </section>
    )
}

export default QuestionnaireGetCare;